import React from 'react'

const Logo = ({ className = '', src = '/logo-full.jpg' }) => {
    return (
        <div className={` flex items-center justify-center ${className}`}>
            <img
                src={src}
                alt="Brand Logo"
                className="object-contain w-full h-full"
            />
        </div>
    )
}

export default Logo